import { CollectExample } from "./CollectExample";

export default CollectExample;
